import gql from "graphql-tag";

const REMOVE_PHOTO_FROM_GALLERY = gql`
  mutation removePhotoFromGallery($companyId: ID!, $filename: String!) {
    removePhotoFromGallery(companyId: $companyId, filename: $filename)
  }
`;

export default REMOVE_PHOTO_FROM_GALLERY;
